import styled from 'styled-components';

export const AddressModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 2rem;
`;

export const AddressCardsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin-top: 3rem;
`;

export const ActionsRowWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const FormWrapper = styled.div`
  width: 100%;
`;
